<template>
    <span :key="`${id}-${$i18n.locale}`">{{ time }}</span>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";

export default {
    name: "PassedTimeCounterAgo",
    props: {
        date: {
            type: String,
            default: null,
        },
        id: {
            type: String,
            default: "",
        },
    },
    computed: mapState({
        timeDiff: (state) => state.auth.timeDiff,
    }),
    data() {
        return {
            time: "",
            interval: null,
        };
    },
    methods: {
        start() {
            this.interval = setInterval(this.incrementTime, 1000);
        },
        incrementTime() {
            this.time = moment(this.date)
                .add(this.timeDiff * -1, "seconds")
                .fromNow();
        },
    },
    mounted() {
        this.start();
    },
    beforeDestroy() {
        clearInterval(this.interval);
    },
    updated() {
        if (moment.locale() !== this.$i18n.locale) moment.locale(this.$i18n.locale);
    },
};
</script>

<style scoped></style>
